import "features/messages/src/styles/ChannelList/index.scss";

export function EmptyGroupChannelListIndicator() {
  return (
    <div className="team-empty-channel-list-indicator">
      There are no group channels. Start by creating some.
    </div>
  );
}

export function EmptyDMChannelListIndicator() {
  return (
    <div className="team-empty-channel-list-indicator">
      There are no DM channels. Start by creating some.
    </div>
  );
}
